import Banner from "@/components/landing/faqs/Banner";
import FaqsBody from "@/components/landing/faqs/FaqsBody";

export default function Faqs() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Faqs Body section */}
      <FaqsBody />
    </>
  );
}
